<template>
  <div class="m-l-50 m-t-30" v-loading="isLoading">
    <common-config :id="id" :form="form" :inputList="inputList"></common-config>
  </div>
</template>

<script>
  import http from '../../../../assets/js/http'
  import flowConfig from '../../../../config/flowConfig'
  import commonConfig from './commonConfig'
  export default {
    data() {
      return {
        isLoading: false,
        id: 0,
        contentId: '',
        modelId: '',
        form: {
          name: '',  // 操作名
          rule_name: '', // 权限标识
          model_name: ''  // 所选模型
        },
        deleteShow: false,  // 删除分组提示显示标识
        inputList: [] // 控件数组
      }
    },
    methods: {
      getDetail() {
        this.isLoading = true
        this.apiGet(`cms/deals/${this.id}`).then((res) => {
          if (res.code == 200) {
            this.form.name = res.data.content_name
            this.form.rule_name = res.data.rule_name
            this.form.model_name = res.data.model_name
            this.modelId = res.data.model_id
            this.getInputList()
          } else {
            _g.dealError(this, res)
          }
          this.isLoading = false
        })
      },
      getInputList() {  // 获取控件列表
        this.apiGet(`form/models/${this.modelId}/fields`).then((res) => {
          if (res.code == 200) {
            this.inputList = res.data
          }
        })
      },
      save() {
        this.isLoading = true
        let config = _.cloneDeep(this.form)
        delete config.name
        delete config.rule_name
        delete config.model_name
        let postData = {
          config: config
        }
        this.apiPut(`cms/deals/${this.id}`, '', postData).then((res) => {
          if (res.code == 200) {
            _g.toastMsg(this, 'success', '保存成功！')
            setTimeout(() => {
              this.goback()
            }, 1000)
          } else {
            _g.dealError(this, res)
            this.isLoading = false
          }
        })
      },
      goback() {
        router.go(-1)
      }
    },
    computed: {
      showCondition() {
        return this.form.has_condition == 1
      }
    },
    created() {
      this.id = parseInt(this.$route.params.id)
      this.contentId = parseInt(this.$route.params.contentId)
      this.getDetail()
    },
    components: {
      commonConfig
    },
    mixins: [http, flowConfig]
  }
</script>


// WEBPACK FOOTER //
// searchConfig.vue?80e6df44